import { UPDATE_PARKING_MARKER_ID } from "./parkingMarkerIdReducer"

export const updateMarkerId = (data) => ({
    type: UPDATE_PARKING_MARKER_ID,
    payload: data
})